import { ThemeServiceInterface } from "./types/themeService.interface"
import { CustomTheme } from "./types/customTheme.interface"
import { ThemeConfig } from "./types/themeConfig.interface"
import { ModeEnum } from "./types/mode.enum"

export class ThemeService implements ThemeServiceInterface {
    defaultMode: ModeEnum

    private theme: CustomTheme

    constructor(theme: CustomTheme) {
        this.theme = theme
        this.defaultMode = theme.defaultMode
    }

    get brand() {
        return this.theme.brand
    }

    async getThemeSettings(): Promise<ThemeConfig> {
        return await this.theme.getTheme()
    }
}